import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { canAccessRoute, getFirstAccessibleAdminRoute } from '../helpers/permissions'
import { usePermissions } from '../contexts/PermissionsContext'

interface AdminPermissionRouteProps {
  children: React.ReactNode
}

const AdminPermissionRoute = ({ children }: AdminPermissionRouteProps) => {
  const location = useLocation()
  const { permissions, isLoading } = usePermissions()

  if (isLoading) {
    return <></>
  }

  if (!canAccessRoute(location.pathname, permissions)) {
    const fallbackRoute = getFirstAccessibleAdminRoute(permissions)
    if (!fallbackRoute || fallbackRoute === location.pathname) {
      return <p>You do not have permission to access any admin modules.</p>
    }
    return <Navigate to={fallbackRoute} replace />
  }

  return <>{children}</>
}

export default AdminPermissionRoute
